export default __webpack_public_path__ + "static/media/brown-2.1246fc5a.png";